import { render, staticRenderFns } from "./MyCommande.vue?vue&type=template&id=d5257458&"
import script from "./MyCommande.vue?vue&type=script&lang=js&"
export * from "./MyCommande.vue?vue&type=script&lang=js&"
import style0 from "./MyCommande.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports